import { Link } from "react-router-dom";

const POLICIES = [
  { label: "Terms of Use", href: "/terms" },
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Refund Policy", href: "/refund" },
];

export default function Footer() {
  return (
    <footer className="relative w-full bg-ink-950 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        {/* Top */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-16 mb-14">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-cream-50">
                <span className="font-display font-bold text-ink-950 text-sm leading-none">I</span>
              </div>
              <span className="font-display font-bold text-xl text-cream-50 tracking-tight">
                Trevica&nbsp;<span className="font-sans font-light text-cream-50/50 text-sm tracking-widest">LTD</span>
              </span>
            </Link>
            <p className="mt-5 max-w-xs text-sm text-cream-50/60 leading-relaxed">
              Utility application development and full-cycle digital marketing — from idea to millions of users.
            </p>
          </div>

          {/* Address */}
          <div>
            <p className="text-[11px] uppercase tracking-[0.2em] font-medium text-cream-50/40 mb-5">
              Office
            </p>
            <address className="not-italic text-sm text-cream-50/60 leading-relaxed space-y-1">
              <p>307 Cotton Exchange</p>
              <p>Old Hall Street</p>
              <p>Liverpool, L3 9LQ</p>
              <p>United Kingdom</p>
            </address>
            <div className="mt-5 space-y-2">
              <a
                href="mailto:support@trevicatech.com"
                className="flex items-center gap-2 text-sm text-cream-50/60 hover:text-amber-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line text-amber-400"></i>
                support@trevicatech.com
              </a>
              <a
                href="tel:+447451257027"
                className="flex items-center gap-2 text-sm text-cream-50/60 hover:text-amber-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-amber-400"></i>
                +44 7451 257027
              </a>
            </div>
          </div>

          {/* Policies */}
          <div>
            <p className="text-[11px] uppercase tracking-[0.2em] font-medium text-cream-50/40 mb-5">
              Legal
            </p>
            <ul className="space-y-3">
              {POLICIES.map((p) => (
                <li key={p.label}>
                  <Link
                    to={p.href}
                    className="text-sm text-cream-50/60 hover:text-amber-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {p.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-cream-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-cream-50/40">
            © {new Date().getFullYear()} Trevica LTD. All rights reserved.
          </p>
          <p className="text-xs text-cream-50/30">
            Registered in England and Wales.
          </p>
        </div>
      </div>
    </footer>
  );
}